import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Form,
  Modal,
  Row,
  Col,
  Dropdown,
} from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import {
  FiEdit,
  FiTrash,
  FiChevronLeft,
  FiChevronRight,
  FiEye,
  FiFileText,
  FiDownload,
  FiFile,
} from "react-icons/fi";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { debounce } from "lodash";
import moment from "moment-timezone";
const timeZone = "America/Tegucigalpa"; // GMT-6
const API_HOST = process.env.REACT_APP_API_URL;
const cookies = new Cookies();

const Paquetes = () => {
  const nowInZone = moment.tz(timeZone).toDate();
  const [data, setData] = useState({
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 5,
    data: [],
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [clientes, setClientes] = useState([]);
  const [searchTermCliente, setSearchTermCliente] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const itemsPerPageOptions = [5, 10, 20, 50];

  const [formData, setFormData] = useState({
    tracking: "",
    tipoEnvio: "",
    pesoProveedor: 0,
    pesoMbox: 0,
    reempaque: "no",
    tipo: "",
    empresa: "",
    estado: "",
    origen: "MIAMi",
    fechaMiami: "",
    fechaProbable: "",
    fechaHonduras: "",
    anakel: "",
    idCliente: "0",
  });

  useEffect(() => {
    fetchData();
  }, [data.currentPage, data.pageSize, searchTerm]);

  const fetchData = async () => {
    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(
        `${API_HOST}/paquetes?page=${data.currentPage}&pageSize=${data.pageSize}&search=${searchTerm}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: "457896",
          },
        }
      );
      const result = await response.json();
      console.log(result);
      setData(result);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchClientes = async () => {
    const bearertoken = cookies.get("token");

    try {
      const response = await fetch(
        `${API_HOST}/clientes?export=true&search=${searchTermCliente}`,
        {
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: "457896",
          },
        }
      );
      const result = await response.json();
      setClientes(result);
    } catch (error) {
      console.error("Error fetching clientes:", error);
      throw error;
    }
  };

  useEffect(() => {
    return () => {
      debouncedFetchClientes.cancel();
    };
  }, []);

  const debouncedFetchClientes = debounce(async () => {
    if (searchTermCliente.length > 2) {
      // Solo buscar si tiene al menos 3 caracteres
      await fetchClientes();
    }
  }, 500);

  const validateSelectedCliente = () => {
    const selected = clientes.find(
      (cliente) =>
        `${cliente.nombre} (${
          cliente.tipoClienteInfo?.descuento || 0
        }% desc)` === searchTermCliente
    );

    if (selected) {
      setFormData((prev) => ({ ...prev, idCliente: selected.idCliente }));
      setErrors((prev) => ({ ...prev, idCliente: "" }));
    } else {
      setFormData((prev) => ({ ...prev, idCliente: "" }));
      setErrors((prev) => ({
        ...prev,
        idCliente: "Seleccione un cliente válido",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    const camposObligatorios = {
      tracking: "El tracking es obligatorio",
      tipoEnvio: "Debe seleccionar un tipo de envío",
      origen:"Origen es obligatorio",
      estado: "Debe seleccionar un estado",
      fechaMiami: "La fecha de Miami es obligatoria",
      fechaProbable: "La fecha probable es obligatoria",
      fechaHonduras: "La fecha de Honduras es obligatoria",
    };

    Object.entries(camposObligatorios).forEach(([campo, mensaje]) => {
      if (!formData[campo] || formData[campo].toString().trim() === "") {
        newErrors[campo] = mensaje;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleView = (item) => {
    setSelectedItem(item);
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handleShowModal = (item = null) => {
    if (item) {
      const formattedItem = {
        ...item,
        fechaMiami: item.fechaMiami?.split("T")[0],
        fechaProbable: item.fechaProbable?.split("T")[0],
        fechaHonduras: item.fechaHonduras?.split("T")[0],
      };
      setFormData(formattedItem);
      setEditingId(item.idPaquete);
    } else {
      setFormData({
        tracking: "",
        tipoEnvio: "",
        pesoProveedor: 0,
        pesoMbox: 0,
        reempaque: "no",
        tipo: "",
        empresa: "",
        estado: "",
        fechaMiami: "",
        fechaProbable: "",
        fechaHonduras: "",
        anakel: "",
        idCliente: "",
      });
      setSearchTermCliente("");
      setEditingId(null);
    }
    setErrors({});
    setShowModal(true);
  };

 const handleChange = (e) => {
    const { name, value } = e.target;
    
    let newFormData = { ...formData, [name]: value };

    // Validamos que tanto MIAMI como MIAMI-EXPRESS vayan a la bodega de Miami
    if (name === "origen" && value) {
      newFormData.estado = value.includes("MIAMI") ? "En bodega(Miami)" : "En bodega(México)";
    }

    const fechaActual = name === "fechaMiami" ? value : formData.fechaMiami;
    const origenActual = name === "origen" ? value : formData.origen;

    if (fechaActual) {
      const [year, month, day] = fechaActual.split("-").map(Number);
      const fechaSeleccionada = new Date(year, month - 1, day);
      const diaSemana = fechaSeleccionada.getDay();

      // Cambiamos la validación para que aplique a MIAMI-EXPRESS
      const esMiamiExpress = origenActual === "MIAMI-EXPRESS";
      
      // 4 = Jueves (MIAMI-EXPRESS), 5 = Viernes (MIAMI normal)
      const diaObjetivo = esMiamiExpress ? 4 : 5; 
      
      let diaEncontrado = new Date(fechaSeleccionada);

      if (diaSemana !== diaObjetivo) {
        const diasFaltantes = (diaObjetivo - diaSemana + 7) % 7;
        diaEncontrado.setDate(fechaSeleccionada.getDate() + diasFaltantes);
      }

      let diasASumar = 0;
      if (esMiamiExpress) {
        // Lógica de MIAMI-EXPRESS: Siempre suma 7 días al jueves
        diasASumar = 7;
      } else {
        // Lógica de MIAMI normal: 21 días si cayó en viernes, 14 si no
        diasASumar = diaSemana === diaObjetivo ? 21 : 14;
      }

      const fechaEntrega = new Date(diaEncontrado);
      fechaEntrega.setDate(diaEncontrado.getDate() + diasASumar);

      newFormData.fechaProbable = formatDateForInput(fechaEntrega);
      newFormData.fechaHonduras = formatDateForInput(fechaEntrega);
    }

    setFormData(newFormData);

    if (errors[name]) {
      setErrors({ ...errors, [name]: null });
    }
  };
  
  function formatDateForInput(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleCloseModal = () => {
    setSearchTermCliente("");
    setShowModal(false);
  };

  const handleSubmit = async () => {
    const bearertoken = cookies.get("token");
    if (!validateForm()) {
      Swal.fire(
        "Error",
        "Por favor complete todos los campos requeridos",
        "error"
      );
      return;
    }

    const method = editingId ? "PUT" : "POST";
    const url = editingId ? `/paquetes/${editingId}` : "/paquetes";

    try {
      const response = await fetch(`${API_HOST + url}`, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${bearertoken}`,
          API: "457896",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        if (response.status === 409) {
          const errorData = await response.json();
          Swal.fire(
            "Error",
            errorData.message || "Ya existe un paquete con este tracking",
            "error"
          );
          return;
        }
        throw new Error("Error en la solicitud");
      }

      Swal.fire(
        "Éxito",
        editingId
          ? "Paquete actualizado correctamente"
          : "Paquete creado correctamente",
        "success"
      );
      fetchData();
      handleCloseModal();
      const result = await response.json();

      let idPaquete;

      if (editingId) {
        idPaquete = editingId;
      } else {
        idPaquete = result.idPaquete;
      }

      const dataToSend = {
        ...formData,
        idPaquete: idPaquete,
      };

      if (formData.idCliente !== "") {
        await fetch(`${API_HOST}/ordenes/paquetes`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${bearertoken}`,
            API: "457896",
          },
          body: JSON.stringify(dataToSend),
        });
      }
      setFormData({
        tracking: "",
        tipoEnvio: "",
        pesoProveedor: 0,
        pesoMbox: 0,
        reempaque: "no",
        tipo: "",
        empresa: "",
        estado: "",
        fechaMiami: "",
        fechaProbable: "",
        fechaHonduras: "",
        anakel: "",
        idCliente: "",
      });
    } catch (error) {
      console.log(error);
      Swal.fire("Error", "Hubo un problema en la operación", "error");
    }
  };

  const exportData = async (format) => {
    const bearertoken = cookies.get("token");
    try {
      const response = await fetch(
        `${API_HOST}/paquetes?export=true&search=${searchTerm}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${bearertoken}`,
            API: "457896",
            "Content-Type": "application/json", // Recomendado para APIs REST
          },
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al exportar los datos");
      }
      const result = await response.json();
      if (format === "excel") {
        exportToExcel(result);
      } else if (format === "pdf") {
        exportToPDF(result);
      }
    } catch (error) {
      Swal.fire(
        "Error",
        error.message || "No se pudieron exportar los datos",
        "error"
      );
    }
  };

  const exportToExcel = (exportData) => {
    const excelData = exportData.map((item) => ({
      ID: item.idPaquete,
      Nombre: item.nombreCliente || "N/A", // Agregado para coincidir con la estructura de clientes
      Tracking: item.tracking,
      "Tipo Envío": item.tipoEnvio,
      "Peso Proveedor (lbs)": item.pesoProveedor,
      "Peso Mbox (lbs)": item.pesoMbox,
      Reempaque: item.reempaque === "sí" ? "Sí" : "No",
      Tipo: item.tipo,
      Empresa: item.empresa,
      Estado: item.estado,
      "Fecha Miami": item.fechaMiami ? item.fechaMiami.slice(0, 10) : "N/A",
      "Fecha Probable": item.fechaProbable
        ? item.fechaProbable.slice(0, 10)
        : "N/A",
      "Fecha Honduras": item.fechaHonduras
        ? item.fechaHonduras.slice(0, 10)
        : "N/A",
      Anakel: item.anakel || "N/A",
      "Fecha Creación": item.createdAt ? item.createdAt.slice(0, 10) : "N/A",
      "Última Actualización": item.updatedAt
        ? item.updatedAt.slice(0, 10)
        : "N/A",
    }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(excelData);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Paquetes");

    const colWidths = [
      { wch: 5 }, // ID
      { wch: 25 }, // Nombre
      { wch: 20 }, // Tracking
      { wch: 12 }, // Tipo Envío
      { wch: 15 }, // Peso Proveedor
      { wch: 12 }, // Peso Mbox
      { wch: 10 }, // Reempaque
      { wch: 15 }, // Tipo
      { wch: 20 }, // Empresa
      { wch: 20 }, // Estado
      { wch: 12 }, // Fecha Miami
      { wch: 12 }, // Fecha Probable
      { wch: 12 }, // Fecha Honduras
      { wch: 15 }, // Anakel
      { wch: 15 }, // Fecha Creación
      { wch: 15 }, // Última Actualización
    ];
    worksheet["!cols"] = colWidths;

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "2c3e50" } },
      alignment: { horizontal: "center" },
      border: {
        top: { style: "thin", color: { rgb: "1a1a1a" } },
        bottom: { style: "thin", color: { rgb: "1a1a1a" } },
        left: { style: "thin", color: { rgb: "1a1a1a" } },
        right: { style: "thin", color: { rgb: "1a1a1a" } },
      },
    };

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const headerCell = XLSX.utils.encode_cell({ r: range.s.r, c: C });
      if (!worksheet[headerCell].s) worksheet[headerCell].s = {};
      Object.assign(worksheet[headerCell].s, headerStyle);

      for (let R = range.s.r + 1; R <= range.e.r; ++R) {
        const cell = XLSX.utils.encode_cell({ r: R, c: C });
        if (!worksheet[cell]) continue;
        if (!worksheet[cell].s) worksheet[cell].s = {};
        worksheet[cell].s.border = {
          top: { style: "thin", color: { rgb: "e0e0e0" } },
          bottom: { style: "thin", color: { rgb: "e0e0e0" } },
          left: { style: "thin", color: { rgb: "e0e0e0" } },
          right: { style: "thin", color: { rgb: "e0e0e0" } },
        };
        if ([0, 2, 3, 4, 5, 6, 9, 10, 11, 12, 13, 14, 15].includes(C)) {
          // Añadido 15
          worksheet[cell].s.alignment = { horizontal: "center" };
        }
      }
    }

    const title = "Listado de Paquetes";
    const company = "MBOX";
    const date = new Date().toLocaleDateString("en-CA", {
      // Cambiado a en-CA
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    const infoSheet = XLSX.utils.aoa_to_sheet([
      [title],
      [""],
      [`Empresa: ${company}`],
      [`Fecha de exportación: ${date}`],
      [`Total paquetes: ${exportData.length}`], // Corrección: Usar exportData.length
      [""],
    ]);

    infoSheet["A1"].s = { font: { bold: true, size: 16 } };
    infoSheet["A3"].s = { font: { italic: true } };
    infoSheet["A4"].s = { font: { italic: true } };
    infoSheet["A5"].s = { font: { bold: true } };

    XLSX.utils.book_append_sheet(workbook, infoSheet, "Informe");

    XLSX.writeFile(
      workbook,
      `Paquetes_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  };

  const exportToPDF = (exportData) => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("Listado de Paquetes", 14, 15);

    doc.setFontSize(10);
    doc.text(`Exportado: ${new Date().toLocaleString()}`, 14, 22);

    autoTable(doc, {
      head: [
        [
          "ID",
          "Nombre",
          "Tracking",
          "Tipo Envío",
          "Peso Proveedor",
          "Peso Mbox",
          "Estado",
        ], // Añadido Nombre
      ],
      body: exportData.map((item) => [
        item.idPaquete,
        item.nombreCliente || "N/A", // Agregado para coincidir con la estructura de clientes
        item.tracking,
        item.tipoEnvio,
        item.pesoProveedor,
        item.pesoMbox,
        item.estado,
      ]),
      startY: 25,
      styles: {
        fontSize: 8,
        cellPadding: 1,
      },
      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: "bold",
      },
      alternateRowStyles: {
        fillColor: [245, 245, 245],
      },
      tableWidth: "auto",
      margin: { left: 10, right: 10, top: 25 },
    });

    doc.save("paquetes.pdf");
  };

  const handleDelete = async (idPaquete) => {
    const bearertoken = cookies.get("token");
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción eliminará el paquete permanentemente",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await fetch(`${API_HOST}/paquetes/${idPaquete}`, {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${bearertoken}`,
              API: "457896",
            },
          });

          if (response.ok) {
            Swal.fire(
              "Eliminado",
              "El paquete ha sido eliminado correctamente",
              "success"
            );
            fetchData();
          } else {
            Swal.fire(
              "Error",
              "Hubo un problema al eliminar el paquete",
              "error"
            );
          }
        } catch (error) {
          console.error("Error deleting paquete:", error);
          Swal.fire("Error", "No se pudo conectar con el servidor", "error");
        }
      }
    });
  };

  const handlePageClick = ({ selected }) => {
    setData({ ...data, currentPage: selected + 1 });
  };

  const handleItemsPerPageChange = (e) => {
    setData({ ...data, pageSize: Number(e.target.value), currentPage: 1 });
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setData({ ...data, currentPage: 1 });
  };

  const pageCount = data.totalPages;

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString("es-ES", options);
  };

  return (
    <div className='container-fluid mt-4'>
      <div className='card border-0 shadow-sm'>
        <div className='card-body'>
          <div className='d-flex justify-content-between mb-4'>
            <h5 className='card-title mb-0'>Gestión de Paquetes</h5>
            <div>
              <Dropdown className='d-inline me-2'>
                <Dropdown.Toggle variant='outline-primary' size='sm'>
                  <FiDownload className='me-1' /> Exportar
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => exportData("excel")}>
                    <FiFileText className='me-2' /> Excel (.xlsx)
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => exportData("pdf")}>
                    <FiFile className='me-2' /> PDF (.pdf)
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Button
                variant='success'
                onClick={() => handleShowModal()}
                size='sm'
              >
                Agregar Nuevo
              </Button>
            </div>
          </div>
          <div className='d-flex justify-content-between mb-3'>
            <Form.Control
              type='text'
              placeholder='Buscar por tracking, estado o fecha de modificación'
              value={searchTerm}
              onChange={handleSearchChange}
              style={{ width: "70%" }}
              className='border'
            />
            <div className='d-flex align-items-center'>
              <span className='me-2 text-muted'>Mostrar:</span>
              <Form.Select
                value={data.pageSize}
                onChange={handleItemsPerPageChange}
                style={{ width: "80px" }}
                className='border'
                size='sm'
              >
                {itemsPerPageOptions.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>{" "}
          <div className='table-responsive'>
            <Table hover className='mb-0'>
              <thead>
                <tr>
                  <th className='border-top-0'>Código</th>
                  <th className='border-top-0'>Cliente</th>
                  <th className='border-top-0'>Tracking</th>
                  <th className='border-top-0'>Tipo Envío</th>
                  <th className='border-top-0'>Origen</th>
                  <th className='border-top-0'>Fecha</th>
                  <th className='border-top-0'>Anakel</th>
                  <th className='border-top-0'>Fecha Probable</th>
                  <th className='border-top-0'>Estado</th>
                  <th className='border-top-0'>Fecha de Modificación</th>
                  <th className='border-top-0 text-end'>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {data.data.map((item) => (
                  <tr key={item.idPaquete}>
                    <td className='text-muted'>{item.idPaquete}</td>
                    <td className='text-muted'>{item.nombreCliente}</td>
                    <td>{item.tracking}</td>
                    <td>{item.tipoEnvio}</td>
                    <td>{item.origen}</td>

                    <td>
                      {item.fechaMiami ? formatDate(item.fechaMiami) : "N/A"}
                    </td>
                    <td>{item.anakel ? item.anakel : "N/A"}</td>
                    <td>
                      {item.fechaHonduras
                        ? formatDate(item.fechaHonduras)
                        : "N/A"}
                    </td>
                    <td>{item.estado}</td>
                    <td>
                      {new Date(item.updatedAt).toLocaleDateString("en-CA")}
                    </td>

                    <td className='text-end'>
                      <Button
                        variant='outline-warning'
                        onClick={() => handleShowModal(item)}
                        className='me-2'
                        title='Editar'
                        size='sm'
                      >
                        <FiEdit />
                      </Button>
                      <Button
                        variant='outline-danger'
                        onClick={() => handleDelete(item.idPaquete)}
                        className='me-2 action-btn'
                        title='Eliminar'
                        size='sm'
                      >
                        <FiTrash />
                      </Button>
                      <Button
                        variant='outline-info'
                        onClick={() => handleView(item)}
                        className='me-2 action-btn'
                        title='ver'
                        size='sm'
                      >
                        <FiEye />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className='d-flex justify-content-between align-items-center mt-3'>
            <div className='text-muted small'>
              Mostrando {data.data.length} de {data.totalItems} registros
            </div>
            <ReactPaginate
              previousLabel={<FiChevronLeft size={14} />}
              nextLabel={<FiChevronRight size={14} />}
              pageCount={pageCount}
              onPageChange={handlePageClick}
              containerClassName={"pagination mb-0"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
              breakLabel='...'
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              forcePage={data.currentPage - 1}
            />
          </div>
        </div>
      </div>

      {/* Modal para agregar/editar */}
      <Modal show={showModal} onHide={handleCloseModal} centered size='lg'>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>{editingId ? "Editar" : "Agregar"} Paquete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Tracking
                  </Form.Label>
                  <Form.Control
                    type='text'
                    name='tracking'
                    value={formData.tracking}
                    onChange={handleChange}
                    isInvalid={!!errors.tracking}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.tracking}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Tipo Envío
                  </Form.Label>
                  <Form.Select
                    name='tipoEnvio'
                    value={formData.tipoEnvio}
                    onChange={handleChange}
                    isInvalid={!!errors.tipoEnvio}
                    className='border'
                  >
                    <option value=''>Seleccionar Tipo de Envío</option>
                    <option value='Aéreo'>Aéreo</option>
                    <option value='Marítimo'>Marítimo</option>
                  </Form.Select>
                  <Form.Control.Feedback type='invalid'>
                    {errors.tipoEnvio}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'></span> Peso Proveedor (lbs)
                  </Form.Label>
                  <Form.Control
                    type='number'
                    step='0.01'
                    name='pesoProveedor'
                    value={formData.pesoProveedor}
                    onChange={handleChange}
                    isInvalid={!!errors.pesoProveedor}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.pesoProveedor}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'></span> Peso Mbox (lbs)
                  </Form.Label>
                  <Form.Control
                    type='number'
                    step='0.01'
                    name='pesoMbox'
                    value={formData.pesoMbox}
                    onChange={handleChange}
                    isInvalid={!!errors.pesoMbox}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.pesoMbox}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>* </span>Reempaque
                  </Form.Label>
                  <Form.Select
                    name='reempaque'
                    value={formData.reempaque}
                    onChange={handleChange}
                    className='border'
                  >
                    <option value='no'>No</option>
                    <option value='sí'>Sí</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>Tipo</Form.Label>
                  <Form.Control
                    type='text'
                    name='tipo'
                    value={formData.tipo}
                    onChange={handleChange}
                    isInvalid={!!errors.tipo}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.tipo}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>Empresa</Form.Label>
                  <Form.Control
                    type='text'
                    name='empresa'
                    value={formData.empresa}
                    onChange={handleChange}
                    isInvalid={!!errors.empresa}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.empresa}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            
            <Row>
            
            <Col md={4}>
              <Form.Group className='mb-3'>
                <Form.Label>
                  <span className='text-danger'>*</span> Origen
                </Form.Label>
                <Form.Select
                  name='origen'
                  value={formData.origen}
                  onChange={handleChange}
                  isInvalid={!!errors.origen}
                  className='border'
                >
                  <option value=''>Seleccionar origen</option>
                  <option value='MIAMI'>MIAMI</option>
                  <option value='MIAMI-EXPRESS'>MIAMI-EXPRESS</option>
                  <option value='MÉXICO'>MÉXICO</option>
                </Form.Select>
                <Form.Control.Feedback type='invalid'>
                  {errors.origen}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

              <Col md={4}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Estado
                  </Form.Label>
                  <Form.Select
                    name='estado'
                    value={formData.estado}
                    onChange={handleChange}
                    isInvalid={!!errors.estado}
                    className='border'
                  >
                    <option value=''>Seleccionar estado</option>
                    <option value='En bodega(Miami)'>En bodega(Miami)</option>
                    <option value='En bodega(México)'>En bodega(México)</option>
                    <option value='En Tránsito'>En tránsito</option>
                    <option value='Listo para entrega'>
                      Listo para entrega
                    </option>
                  </Form.Select>
                  <Form.Control.Feedback type='invalid'>
                    {errors.estado}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className='mb-3'>
                  <Form.Label>Anakel</Form.Label>
                  <Form.Control
                    list='anakel-options'
                    type='text'
                    name='anakel'
                    value={formData.anakel}
                    onChange={handleChange}
                    isInvalid={!!errors.anakel}
                    className='border'
                    placeholder='Selecciona o escribe una opción'
                  />
                  <datalist id='anakel-options'>
                    {/* Opciones del datalist - puedes reemplazar con tus datos dinámicos */}
                    <option value='A1' />
                    <option value='A2' />
                    <option value='A3' />
                    <option value='A4' />
                    <option value='A5' />
                    <option value='B1' />
                    <option value='B2' />
                    <option value='B3' />
                    <option value='B4' />
                    <option value='B5' />
                    <option value='C1' />
                    <option value='C2' />
                    <option value='C3' />
                    <option value='C4' />
                    <option value='C5' />
                    <option value='D1' />
                    <option value='D2' />
                    <option value='D3' />
                    <option value='D4' />
                    <option value='D5' />
                  </datalist>
                  <Form.Control.Feedback type='invalid'>
                    {errors.anakel}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Fecha Miami
                  </Form.Label>
                  <Form.Control
                    type='date'
                    name='fechaMiami'
                    value={formData.fechaMiami}
                    onChange={handleChange}
                    isInvalid={!!errors.fechaMiami}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.fechaMiami}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Fecha Probable
                  </Form.Label>
                  <Form.Control
                    type='date'
                    name='fechaProbable'
                    value={formData.fechaProbable}
                    onChange={handleChange}
                    isInvalid={!!errors.fechaProbable}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.fechaProbable}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className='mb-3'>
                  <Form.Label>
                    <span className='text-danger'>*</span> Fecha Honduras
                  </Form.Label>
                  <Form.Control
                    type='date'
                    name='fechaHonduras'
                    value={formData.fechaHonduras}
                    onChange={handleChange}
                    isInvalid={!!errors.fechaHonduras}
                    className='border'
                  />
                  <Form.Control.Feedback type='invalid'>
                    {errors.fechaHonduras}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
          </Form>
          <Row className='mb-3'>
            <Col md={12}>
              <Form.Group>
                <Form.Label>
                  <span className='text-danger'>*</span> Cliente
                </Form.Label>
                <Form.Control
                  list='clientes-list'
                  type='text'
                  name='clienteSearch'
                  value={searchTermCliente}
                  onChange={(e) => {
                    setSearchTermCliente(e.target.value);
                    // Opcional: agregar debounce para evitar muchas llamadas
                    debouncedFetchClientes();
                  }}
                  onBlur={() => {
                    // Validar que el cliente seleccionado exista en la lista
                    validateSelectedCliente();
                  }}
                  isInvalid={!!errors.idCliente}
                  className='border'
                  placeholder='Escribe para buscar cliente...'
                />
                <datalist id='clientes-list'>
                  {clientes.map((cliente) => (
                    <option
                      key={cliente.idCliente}
                      value={`${cliente.nombre} (${
                        cliente.tipoClienteInfo?.descuento || 0
                      }% desc)`}
                      data-id={cliente.idCliente}
                    />
                  ))}
                </datalist>
                <Form.Control
                  type='hidden'
                  name='idCliente'
                  value={formData.idCliente}
                  onChange={handleChange}
                />
                <Form.Control.Feedback type='invalid'>
                  {errors.idCliente}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseModal}>
            Cancelar
          </Button>
          <Button variant='primary' onClick={handleSubmit}>
            {editingId ? "Actualizar" : "Guardar"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal para ver detalles */}
      <Modal show={showViewModal} onHide={handleCloseViewModal} centered>
        <Modal.Header closeButton className='border-bottom'>
          <Modal.Title>
            <FiEye className='me-2 text-primary' />
            Detalles del Paquete
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <div>
              <div className='mb-3'>
                <h6 classNameclassName='text-muted mb-2'>Información Básica</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>Código:</span>{" "}
                    {selectedItem.idPaquete}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Tracking:</span>{" "}
                    {selectedItem.tracking}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Tipo Envío:</span>{" "}
                    {selectedItem.tipoEnvio}
                  </p>

                  <p className='mb-2'>
                    <span className='fw-medium'>Origen:</span>{" "}
                    {selectedItem.origen}
                  </p>

                  <p className='mb-0'>
                    <span className='fw-medium'>Estado:</span>{" "}
                    {selectedItem.estado}
                  </p>
                </div>
              </div>

              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Detalles del Paquete</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>Peso Proveedor:</span>{" "}
                    {selectedItem.pesoProveedor} lbs
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Peso Mbox:</span>{" "}
                    {selectedItem.pesoMbox} lbs
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Reempaque:</span>{" "}
                    {selectedItem.reempaque === "sí" ? "Sí" : "No"}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Tipo:</span>{" "}
                    {selectedItem.tipo || "N/A"}
                  </p>
                  <p className='mb-0'>
                    <span className='fw-medium'>Empresa:</span>{" "}
                    {selectedItem.empresa || "N/A"}
                  </p>
                </div>
              </div>

              <div className='mb-3'>
                <h6 className='text-muted mb-2'>Fechas Importantes</h6>
                <div className='ps-3'>
                  <p className='mb-2'>
                    <span className='fw-medium'>Fecha Miami:</span>{" "}
                    {selectedItem.fechaMiami
                      ? formatDate(selectedItem.fechaMiami)
                      : "N/A"}
                  </p>
                  <p className='mb-2'>
                    <span className='fw-medium'>Fecha Probable:</span>{" "}
                    {selectedItem.fechaProbable
                      ? formatDate(selectedItem.fechaProbable)
                      : "N/A"}
                  </p>
                  <p className='mb-0'>
                    <span className='fw-medium'>Fecha Honduras:</span>{" "}
                    {selectedItem.fechaHonduras
                      ? formatDate(selectedItem.fechaHonduras)
                      : "N/A"}
                  </p>
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className='border-top'>
          <Button variant='outline-secondary' onClick={handleCloseViewModal}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Paquetes;
